import React, { Component } from 'react';
import './CheckBox.scss';

export default class CheckBox extends Component {
  constructor(props) {
    super(props);

    this.state = {
      [this.props.name]: false
    };

    this.handleChange = this.handleChange.bind(this);
  }


  handleChange(e) {
    this.setState({ [e.target.name]: e.target.checked });
  };

  render() {
    return (
      <div className={`form_checkmarks ${this.props.className}`} style={this.props.style} >
        <input
          type={this.props.type}
          id={this.props.id}
          name={this.props.name}
          value={this.props.value}
          required={this.props.required}
          disabled={this.props.disabled}
          // defaultChecked={ this.props.checked }
          {...this.props.field}
          onChange={this.props.onChange || this.handleChange}
        />

        <label htmlFor={this.props.id}>
          {this.props.label}
        </label>
      </div>
    )
  }
}
